import { easeIn } from "framer-motion";
import { easeInOut } from 'popmotion';

export const navVariants = {
  hidden: {
    opacity: 0,
    y: -50,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 140,
    },
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 80,
      delay: 0.5,
    },
  },
};

export const animatedText = (delay=0, duration=0)=> ({
  hidden: {
    opacity: 0,
    y: 40,
  },
  show:{
    opacity:1,
    y:0,
    transition:{
        duration,
        delay,
        ease:easeIn,
    }
  }
});

export const slideIn = {
  hidden: {
    x: '-100%',
  },
  show: {
    x: 0,
    y: 0,
    transition: {
      ease: easeInOut, 
      duration: 0.8, 
    },
  },
};

export const floatIn = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 50,
        damping: 8,
      },
    },
  };
  
